/**
 * Handles temperature conversion calculations
 */
export class TemperatureConverter {
  /**
   * Convert Fahrenheit to Celsius
   * @param {number} fahrenheit - Temperature in Fahrenheit
   * @returns {number} Temperature in Celsius
   */
  fahrenheitToCelsius(fahrenheit) {
    return (fahrenheit - 32) * (5 / 9)
  }

  /**
   * Convert Celsius to Fahrenheit
   * @param {number} celsius - Temperature in Celsius
   * @returns {number} Temperature in Fahrenheit
   */
  celsiusToFahrenheit(celsius) {
    return (celsius * (9 / 5)) + 32
  }
}
